<template>
  <section class="content">
    <div class="row center-block">
      <!--<h2>Data tables</h2>-->
      <div class="col-md-12">
        <cr-product />
      </div>
    </div>
</section>
</template>

<script>
import crProduct from './Temp/CrProductTemp.vue'

export default {
  name: 'Tables',
  components: {
    'cr-product': crProduct
  },
  methods: {
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// CrMenuProduct.vue?2032f1f0